import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import Link from "../../link";
import OptionListDescriptionResource from "./option-list-description-resource";

@JsonObject()
export default class OptionListCollectionResource {
    @JsonProperty("items")
    @JsonElementType(OptionListDescriptionResource)
    items: Array<OptionListDescriptionResource>;

    @JsonProperty("self")
    self: Link;
}

export { OptionListCollectionResource };
